<script lang="ts">
    import type { SvelteComponent } from "svelte";
    export let onClick: (e: MouseEvent) => void;
    export let title: string|undefined = undefined;
    export let icon: SvelteComponent|any|undefined = undefined;
    export let active: boolean = false;
    export let color: string = '#B2B2B2';
    export let width: string = '24px';
    export let height: string = '24px';
</script>
<button type="button" class="IconButton" class:active="{active === true}" on:click|preventDefault={onClick} title={title ? title : null}>
    {#if icon}
        <svelte:component this={icon} {width} {height} color={color} />
    {/if}
</button>

<style type="text/scss">
    .IconButton {
        appearance: none;
        border: none;
        box-shadow: none;
        background: transparent;
        padding: 0;
        display: inline-block;
        cursor: pointer;
        margin: 0;
        line-height: 24px;
        height: 24px;
        outline: none;
        &:active {
            background: transparent;
        }
    }
    :global(.IconButton:focus svg) {
        fill: rgb(138, 138, 138)!important;
    }
    :global(.IconButton:hover svg) {
        fill: rgb(138, 138, 138)!important;
    }
    :global(.IconButton.active svg) {
        fill: #4A4A4A!important;
    }
    :global(svg) {
        vertical-align: middle;
    }
</style>
